/**
 * A small, non-blocking notice for the storefront, used instead of popups.
 * It appears at the bottom of the screen, does not stop the shopper, and
 * disappears by itself. Screen readers announce it.
 *
 * notify("Added to cart")             success
 * notify("Coupon not valid", "error") error (stays a little longer)
 */
const STYLE_ID = "store-notify-style";
const HOST_ID = "store-notify-host";

function ensureHost() {
  if (typeof document === "undefined") return null;
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      #${HOST_ID}{position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:3000;display:flex;flex-direction:column;gap:8px;align-items:center;pointer-events:none;width:calc(100% - 32px);max-width:420px}
      .store-notify{pointer-events:auto;display:flex;align-items:center;gap:10px;width:100%;padding:12px 14px;border-radius:12px;font:600 14px/1.4 system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;color:#fff;background:#0f172a;box-shadow:0 10px 30px -10px rgba(15,23,42,.45);animation:store-notify-in .2s ease-out}
      .store-notify.is-error{background:#b91c1c}
      .store-notify.is-info{background:#1e3a8a}
      .store-notify button{margin-left:auto;background:none;border:0;color:inherit;opacity:.8;font-size:18px;line-height:1;cursor:pointer;padding:0 2px}
      @keyframes store-notify-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
      @media (max-width:575.98px){#${HOST_ID}{bottom:80px}}
    `;
    document.head.appendChild(style);
  }
  let host = document.getElementById(HOST_ID);
  if (!host) {
    host = document.createElement("div");
    host.id = HOST_ID;
    document.body.appendChild(host);
  }
  return host;
}

export function notify(message, type = "success", { duration } = {}) {
  const host = ensureHost();
  if (!host || !message) return;
  const item = document.createElement("div");
  item.className = `store-notify ${type === "error" ? "is-error" : type === "info" ? "is-info" : ""}`;
  item.setAttribute("role", type === "error" ? "alert" : "status");
  const text = document.createElement("span");
  text.textContent = message;
  const close = document.createElement("button");
  close.type = "button";
  close.setAttribute("aria-label", "Close");
  close.textContent = "×";
  const remove = () => item.parentNode && item.parentNode.removeChild(item);
  close.onclick = remove;
  item.appendChild(text);
  item.appendChild(close);
  host.appendChild(item);
  while (host.children.length > 3) host.removeChild(host.firstChild);
  setTimeout(remove, duration || (type === "error" ? 6000 : 3000));
}
